import { Layouts } from '../../../controls/layouts';
import { Component, model, output, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, NgModelGroup, FormsModule } from '@angular/forms';
import { ContextPropertyFilterComparer } from '../../models/context-property-filter-comparer';
import { Selectbox } from '../../../controls/selectbox';
import { Textbox } from '../../../controls/textbox';
import { LinkComponent } from '../../../controls/components/basic/link/link.component';
import { ContextPropertyFilterDto } from '../../models/context-property-filter-dto';

@Component({
    selector: 'app-context-property-filter',
    templateUrl: './context-property-filter.component.html',
    styleUrls: ['./context-property-filter.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [Layouts, Selectbox, FormsModule, Textbox, LinkComponent]
})
export class ContextPropertyFilterComponent {
  filter = model.required<ContextPropertyFilterDto>();
  readonly = model.required<boolean>();
  readonly selectedComparerKey = 'Equals';
  onDeleteFilter = output();

  constructor() {
  }

  //** Dropdown sources */
  readonly comparers: ContextPropertyFilterComparer[] = [
    { key: 'Equals', name: 'equals' }
  ];

  //** Change event handlers */
  onPropertyNameChange(key: string) {
    if (this.filter().PropertyName !== key) {
      this.filter.update(c => ({...c, PropertyName: key}));
    }
  }

  onPropertyNamespaceChange(key: string) {
    if (this.filter().PropertyNamespace !== key) {
      this.filter.update(c => ({...c, PropertyNamespace: key}));
    }
  }

  onValueChange(idx: number, value: any) {
    if (this.filter().Values[idx].Value !== value) {
    this.filter.update(c => {
        const newValues = [...c.Values];
        newValues[idx].Value = value;
        return {...c, Values: newValues};
    });
    }
  }


  //** User initiated actions */
  addValue(e: any) {
    this.filter.update(c => {
      const newValues = [...c.Values, this.getNewValue()];
      return {...c, Values: newValues};
    });
  }

  deleteValue(idx: number) {
    this.filter.update(c => {
      const newValues = [...c.Values];
      newValues.splice(idx+1, 1)
      return {...c, Values: newValues};
    });
  }

  deleteFilter() {
    this.onDeleteFilter.emit();
  }


  //** Helpers*/
  getNewValue() {
    const newTempId = -Math.floor((Math.random() * 100000) + 1);
    return {Id: newTempId, Value: null}
  }
}
